import {h} from 'ui/Framework';

export default h('svg', {
  width: '47',
  height: '55',
  viewBox: '0 0 47 55',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fillRule: 'nonzero',
    fill: 'none'
  }, [
    h('path', {
      d: 'M14.433 0a1.63 1.63 0 0 0-.772.2 1.623 1.623 0 0 0-.63 2.196l1.752 3.156C10.56 8.156 7.76 12.605 7.76 17.682v.944a4.413 4.413 0 0 0-3.336-1.517C1.982 17.109 0 19.084 0 21.517v13.579c0 2.432 1.982 4.408 4.424 4.408a4.412 4.412 0 0 0 3.336-1.518v1.902c0 2.565 2.105 4.663 4.679 4.663h1.187v6.04c0 2.434 1.982 4.409 4.424 4.409 2.44 0 4.423-1.976 4.423-4.408v-6.04h2.054v6.04c0 2.433 1.982 4.408 4.424 4.408 2.44 0 4.423-1.976 4.423-4.408v-6.04h1.187c2.574 0 4.68-2.1 4.68-4.664v-1.902a4.413 4.413 0 0 0 3.336 1.518c2.44 0 4.423-1.976 4.423-4.408v-13.58c0-2.432-1.982-4.407-4.423-4.407a4.412 4.412 0 0 0-3.337 1.517V17.798v-.115c0-5.077-2.805-9.522-7.028-12.126l1.758-3.16A1.623 1.623 0 0 0 33.34.2a1.63 1.63 0 0 0-.771-.2 1.623 1.623 0 0 0-1.433.829l-1.839 3.31A16.776 16.776 0 0 0 23.5 3.115c-2.04 0-4 .359-5.796 1.019L15.865.829A1.624 1.624 0 0 0 14.433 0z',
      fill: '#F7F9FA'
    }),
    h('path', {
      d: 'M4.22 19C2.427 19 1 20.461 1 22.297v13.734c0 1.836 1.427 3.297 3.22 3.297 1.794 0 3.22-1.461 3.22-3.297V22.297C7.44 20.461 6.015 19 4.22 19zm37.56 0c-1.794 0-3.22 1.461-3.22 3.297v13.734c0 1.836 1.426 3.297 3.22 3.297 1.793 0 3.22-1.461 3.22-3.297V22.297C45 20.461 43.573 19 41.78 19zM17.634 34.672c-1.793 0-3.22 1.461-3.22 3.297v13.734c0 1.836 1.427 3.297 3.22 3.297 1.794 0 3.22-1.461 3.22-3.297V37.969c0-1.836-1.426-3.297-3.22-3.297zm10.732 0c-1.794 0-3.22 1.461-3.22 3.297v13.734c0 1.836 1.426 3.297 3.22 3.297 1.793 0 3.22-1.461 3.22-3.297V37.969c0-1.836-1.427-3.297-3.22-3.297z',
      fill: '#E4F1FD'
    }),
    h('path', {
      d: 'M14.497 1a.453.453 0 0 0-.219.06.446.446 0 0 0-.18.625l2.291 4.123C11.983 8.093 9.006 12.436 9 17.42h29c-.006-4.984-2.983-9.327-7.39-11.612l2.291-4.123a.446.446 0 0 0-.18-.625.454.454 0 0 0-.627.179l-2.32 4.167a15.504 15.504 0 0 0-6.274-1.31c-2.247 0-4.376.471-6.274 1.31l-2.32-4.168A.455.455 0 0 0 14.496 1zM9 18.561v20.946a3.48 3.48 0 0 0 1.025 2.472A3.504 3.504 0 0 0 12.505 43h21.99a3.504 3.504 0 0 0 2.48-1.02A3.48 3.48 0 0 0 38 39.506V18.56H9z',
      fill: '#E4F1FD'
    }),
    h('path', {
      d: 'M17.225 10c-.67 0-1.225.68-1.225 1.5s.555 1.5 1.225 1.5 1.225-.68 1.225-1.5-.555-1.5-1.225-1.5zm13.55 0c-.67 0-1.225.68-1.225 1.5s.555 1.5 1.225 1.5S32 12.32 32 11.5s-.555-1.5-1.225-1.5z',
      fill: '#F7F9FA'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/android.es6.js